
import { memo, useEffect, useState, useMemo } from "react";

import { useLocation } from "react-router-dom";

import { makeStyles, Theme, createStyles, withStyles } from '@material-ui/core/styles';

import { IonAlert, IonCol, IonGrid, IonRow, } from "@ionic/react";
import { BarrLoaderSpiner } from '../../../components/BarrLoaderSpiner';

import Button from '@material-ui/core/Button';

import { SubscriptionPaypalBtn } from "../../../components/SubscriptionPaypalBtn";
import { setTimeout } from "timers";

import { TablePago } from './TablePago';

import configData from "../../../config.json";

import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import CreditCardOutlinedIcon from '@material-ui/icons/CreditCardOutlined';

const apiUrl = (process.env.NODE_ENV !== 'development') ? configData.EndPoint + '/index.php/Paypal' : configData.EndPointLocal + '/index.php/Paypal';

const apiUrlStripe = (process.env.NODE_ENV !== 'development') ? configData.EndPoint + '/index.php/Stripe' : configData.EndPointLocal + '/index.php/Stripe';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        button: {
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        actionsContainer: {
            marginBottom: theme.spacing(2),
        },
        resetContainer: {
            padding: theme.spacing(3),
        },
    }),
);


const BootstrapButtonTransf = withStyles({
    root: {
        boxShadow: 'none',
        textTransform: 'none',
        fontSize: 16,
        padding: '6px 35px',
        border: '1px solid',
        lineHeight: 1.5,
        backgroundColor: '#2C2E2F',
        color: 'white',
        fontWeight: 'normal',
        borderColor: '#2C2E2F',
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
            backgroundColor: '#2C2E2F',
            borderColor: '#2C2E2F',
            boxShadow: 'none',
        },
        '&:active': {
            boxShadow: 'none',
            backgroundColor: '#2C2E2F',
            borderColor: '#2C2E2F',
        },
        '&:focus': {
            boxShadow: '0 0 0 0.2rem rgb(44,46,47)',
        },
    },
})(Button);


const BootstrapButtonStripe = withStyles({
    root: {
        boxShadow: 'none',
        textTransform: 'none',
        fontSize: 16,
        padding: '6px 20px',
        border: '1px solid',
        lineHeight: 1.5,
        backgroundColor: '#2C2E2F',
        color: 'white',
        fontWeight: 'normal',
        borderColor: '#2C2E2F',
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
            backgroundColor: '#2C2E2F',
            borderColor: '#2C2E2F',
            boxShadow: 'none',
        },
        '&:active': {
            boxShadow: 'none',
            backgroundColor: '#2C2E2F',
            borderColor: '#2C2E2F',
        },
        '&:focus': {
            boxShadow: '0 0 0 0.2rem rgb(44,46,47)',
        },
    },
})(Button);

interface IPaypalPlan {
    id: string;
    product_id: string;
    name: string;
    status: string;
    description: string;
    usage_type: string;
    create_time: string;
    links: any;
};

interface IStripeProduct {
    active: boolean;
    billing_scheme: string;
    created: number;
    currency: string;
    id: string;
    livemode: boolean;
    lookup_key: string;
    metadata: any;
    nickname: string;
    object: string;
    product: string;
    recurring: any;
    tax_behavior: string;
    tiers_mode: any;
    transform_quantity: any;
    type: string;
    unit_amount: number;
    unit_amount_decimal: string;
};


const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
};

const setParamsToStripe = () => {
    const registerSchoolKidkiriki: any = window?.localStorage?.getItem('registerSchoolKidkiriki');
    if (!registerSchoolKidkiriki) return;
    const {
        stripeProductId,
        cupon
    } = JSON.parse(registerSchoolKidkiriki);
    return window.location.href = `${apiUrlStripe}/portalStripe/?stripeProductId=${stripeProductId}&cupon=${cupon}`;
};


const Pago = ({
    handleBack,
    formik: {
        values,
        setFieldValue,
        errors
    } }: any) => {

    const classes = useStyles();

    const query = useQuery();
    const cupon: any = query.get("cupon");  // cupon de descuento

    const [showSpinner, setShowSpinner] = useState(true as boolean);
    const [planId, setPlanId] = useState('' as string);
    const [stripeProductId, setStripeProductId] = useState('' as string);

    const [dspAlert, setDspAlert] = useState(false as boolean);

    useEffect(() => {
        const {
            nombre,
            numero_alumnos,
            pais
        } = values.Escuela.DatosInstitucion;

        fetch(`${apiUrl}/createPlan`, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: `nombre=${nombre}&numero_alumnos=${numero_alumnos}&pais=${pais}${cupon ? `&cupon=${cupon}` : ''}`,
        })
            .then(response => response.json())
            .then(planCreated)
            .catch((err) => console.error(err));
    }, []);

    useEffect(() => {
        const {
            nombre,
            numero_alumnos,
            pais
        } = values.Escuela.DatosInstitucion;

        fetch(`${apiUrlStripe}/createProduct`, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: `nombre=${nombre}&numero_alumnos=${numero_alumnos}&pais=${pais}${cupon ? `&cupon=${cupon}` : ''}`,
        })
            .then(response => response.json())
            .then(productStripeCreated)
            .catch((err) => console.error(err));
    }, []);


    const barrLoaderProps: any = {
        spinnerState: { showSpinner, setShowSpinner },
    };

    const planCreated = ({ id }: IPaypalPlan) => {
        setFieldValue({ paypalPlan: id });
        setPlanId(id);
        return setTimeout(() => setShowSpinner(false), 1000);
    };

    const productStripeCreated = ({ id }: IStripeProduct) => {
        setStripeProductId(id);
        window.localStorage.setItem('registerSchoolKidkiriki', JSON.stringify({
            ...values,
            stripeProductId: id,
            cupon
        }));
        return setTimeout(() => setShowSpinner(false), 1000);
    };

    if (showSpinner) return <BarrLoaderSpiner {...barrLoaderProps} />;

    const paypalSubscribe = (_data: any, actions: { subscription: { create: (arg0: { plan_id: string; }) => any; }; }) => actions.subscription.create({ 'plan_id': planId, });

    const paypalOnError = (err: any) => {
        console.log(err);
    };

    const paypalOnApprove = (data: any, detail: any) => {
        console.log("Payapl approved")
        console.log({ data, detail, values });

        var formData = new FormData();

        formData.append('data', JSON.stringify({
            orderID: data.orderID,
            facilitatorAccessToken: data.facilitatorAccessToken,
            subscriptionID: data.subscriptionID,
            ...values,
        }));

        formData.append('logo', values.Escuela.DatosInstitucion.logo);

        return fetch(`${apiUrl}/saveSubscription?`, {
            method: "POST",
            body: formData
        })
            .then(response => response.text())
            .then(er => {
                console.log(er);
                alert(`¡Felicidades! 
                    Has completado tu registro, en breve recibirás un correo con los pasos a seguir 
                    ¡Bienvenidos a la familia Kidkiriki!
                `);
                return window.location.href = 'https://kidkiriki.com/admin_beta';
            })
            .catch((err) => console.error(err));
    };

    const paymentWithElectronicTransfer = () => {

        // eslint-disable-next-line no-restricted-globals
        if (!confirm('¿Estas seguro de que deseas pagar con transferencia electrónica?')) return;

        setDspAlert(true);

        var formData = new FormData();

        formData.append('data', JSON.stringify({
            orderID: 'Pago por transferencia',
            ...values,
        }));

        formData.append('logo', values.Escuela.DatosInstitucion.logo);

        return fetch(`${apiUrl}/saveSubscriptionByElectronicTransfer`, {
            method: "POST",
            body: formData
        })
            .then(response => response.text())
            .then(er => {
                console.log(er);
                alert(`¡Felicidades! 
                    Has completado tu registro, en breve recibirás un correo con los pasos a seguir 
                    ¡Bienvenidos a la familia Kidkiriki!
                `);
                return window.location.href = 'https://kidkiriki.com/admin_beta';
            })
            .catch((err) => console.error(err));
    };

    return (
        <>
            <IonAlert
                isOpen={dspAlert}
                cssClass='my-custom-class'
                header={'Datos para la transferencia'}
                subHeader={""}
                message={`BANAMEX JOCELYN GODOY Suc: 7013 
                Cuenta: 8526303
                Clabe: 002320701385263031`}
                buttons={['OK']}
            />
            <IonGrid className="ion-padding-none">

                <IonRow className="ion-padding-bottom">

                    <IonCol className="ion-text-center">
                        <img
                            src={process.env.PUBLIC_URL + '/assets/img/steps/credit-card-payment.png'}
                            height={120}
                            alt=""
                        />
                    </IonCol>

                </IonRow>

                <IonRow className="ion-padding-bottom">

                    <IonCol sizeXl="4">
                        <TablePago tableProps={{ ...values }} />
                    </IonCol>
                </IonRow>

                <IonRow style={{ paddingBottom: "20px" }}>
                    <BootstrapButtonStripe
                        variant="contained"
                        color="inherit"
                        size="large"
                        onClick={setParamsToStripe}
                        startIcon={<CreditCardOutlinedIcon />}
                    >Pagar con tarjeta
                    </BootstrapButtonStripe>
                </IonRow>

                <IonRow>
                    <SubscriptionPaypalBtn
                        amount="50"
                        currency={values.Escuela.DatosInstitucion?.pais === 'MEXICO' ? 'MXN' : 'USD'}
                        createSubscription={paypalSubscribe}
                        onApprove={paypalOnApprove}
                        catchError={paypalOnError}
                        onError={paypalOnError}
                        onCancel={paypalOnError}
                    />
                </IonRow>

                {values.Escuela.DatosInstitucion?.pais === 'MEXICO' && (
                    <IonRow>
                        <BootstrapButtonTransf
                            variant="contained"
                            color="inherit"
                            onClick={() => paymentWithElectronicTransfer()}
                            startIcon={<ReceiptOutlinedIcon />}
                        >Transferencia
                        </BootstrapButtonTransf>
                    </IonRow>
                )}

                <IonRow>
                    <div>
                        <br />
                        <Button
                            variant="outlined"
                            color="default"
                            onClick={handleBack}
                            className={classes.button}
                        >
                            Regresar
                        </Button>
                    </div>
                </IonRow>

            </IonGrid>

        </>
    );
};

export default memo(Pago);